import { useAppEnvironmentStore } from '../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../stores/AppEnvironment/appEnvironment.store.selectors';
import BrandHome from '../brand-home/BrandHome';
import StoreHome from '../store-home/StoreHome';

const HomeSwitch = () => {
  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);

  return isInStoreEnvironment ? <StoreHome /> : <BrandHome />;
};

export default HomeSwitch;
